import { ComplianceStatusChangedDetails } from '@evidentid/tprm-portal-lib/models/activity-history';

import { CategorizedEnumLabels } from '@/modules/dashboard/models/CategorizedEnumLabels.model';
import { resolveComplianceStatusLabel } from '@/modules/entity-events/utils/resolveComplianceStatusLabel';

/**
 * Human-readable summary for a COMPLIANCE_STATUS_CHANGED entry, e.g.
 * "Entity's compliance status changed from Pending to Compliant", degrading to
 * "Entity's compliance status changed" when the previous/new status is missing.
 */
export function formatComplianceStatusChangedSummary(
    details: ComplianceStatusChangedDetails | null | undefined,
    enumLabels: CategorizedEnumLabels,
): string {
    if (!details?.previousStatus || !details?.newStatus) {
        return 'Entity\'s compliance status changed';
    }
    const previousLabel = resolveComplianceStatusLabel(details.previousStatus, enumLabels);
    const newLabel = resolveComplianceStatusLabel(details.newStatus, enumLabels);
    return `Entity's compliance status changed from ${previousLabel} to ${newLabel}`;
}
